import React from 'react';
import { Snackbar, Alert, Box } from '@mui/material';
import '../../entrevista/components/EntrevistaViewer.css';
import { useAntropometriaViewer } from '../hooks/useAntropometriaViewer';
import {
  AntropometriaHero,
  AntropometriaMetrics,
  PatientProfileSection,
  BaseMetricsSection,
  PerimetroSection,
  CompositionSection,
  ViewerActions,
} from './viewer/AntropometriaViewerSections';

const MedidasAntropometricasViewer = ({ medidaId, pacienteId }) => {
  const {
    patientInfo,
    fields,
    isEditing,
    openGood,
    metrics,
    imcRisk,
    setOpenGood,
    setField,
    handleEdit,
    handleCancel,
    handleSave,
    handleDelete,
    handleExportPDF,
  } = useAntropometriaViewer({ medidaId, pacienteId });

  const onFieldChange = (fieldName) => (event) => setField(fieldName, event.target.value);

  return (
    <Box className="entrevista-viewer" sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Box className="entrevista-viewer__shell" sx={{ maxWidth: 1080, width: '100%' }}>
        <Box id="pdf-content" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <AntropometriaHero createdAt={patientInfo.createdAt} />
          <AntropometriaMetrics metrics={metrics} imcRisk={imcRisk} />
          <PatientProfileSection patientInfo={patientInfo} />
          <BaseMetricsSection fields={fields} isEditing={isEditing} onFieldChange={onFieldChange} />
          <PerimetroSection fields={fields} isEditing={isEditing} onFieldChange={onFieldChange} />
          <CompositionSection fields={fields} isEditing={isEditing} onFieldChange={onFieldChange} />
        </Box>

        <ViewerActions
          isEditing={isEditing}
          onEdit={handleEdit}
          onSave={handleSave}
          onCancel={handleCancel}
          onExportPDF={handleExportPDF}
          onDelete={handleDelete}
        />

        <Snackbar open={openGood} autoHideDuration={2000} onClose={() => setOpenGood(false)}>
          <Alert severity="success" onClose={() => setOpenGood(false)}>
            ¡Informe actualizado!
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
};

export default MedidasAntropometricasViewer;
